"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTriggerOrders = void 0;
const react_1 = require("react");
const TriggersApi_1 = require("../../apis/TriggersApi");
const interface_1 = require("../../interface");
const trade_utils_lib_1 = require("trade_utils_lib");
const usePullRefresh_1 = require("../../hooks/usePullRefresh");
function useTriggerOrders(props, active = true) {
    const { isHistory, symbol, symbolType = "PERP", orderStates, observerWSOrders, accountType, isTPSL = false, onOrderStateChanged, } = props;
    const dataMap = (0, react_1.useRef)(new Map());
    const filterParams = (0, react_1.useMemo)(() => ({
        symbol: symbol !== null && symbol !== void 0 ? symbol : "",
        state: (orderStates || []).join(","),
        symbol_type: symbolType,
        trigger_function: (isTPSL ? "POSITION" : "NORMAL"),
    }), [orderStates, symbol, symbolType, isTPSL]);
    // 记录下原始数据的id
    const onProcessData = (0, react_1.useCallback)((source, indexOffset) => {
        const map = dataMap.current;
        if (indexOffset === 0) {
            map.clear();
        }
        source.forEach((item, index) => {
            map.set(item.trigger_id, { index: index + indexOffset });
        });
        return source;
    }, []);
    const _a = (0, usePullRefresh_1.usePullRefresh)({
        query: isHistory ? TriggersApi_1.queryHistoryTriggers : TriggersApi_1.queryActiveTriggers,
        getLoadMoreParams: (source) => {
            if (!source.length) {
                return undefined;
            }
            return { page_cursor: source[source.length - 1].next_page_cursor };
        },
        onProcessData,
        filterParams,
        pageLimit: 10,
        accountType,
        active,
    }), { setListData } = _a, others = __rest(_a, ["setListData"]);
    const updateRef = (0, react_1.useRef)(setListData);
    (0, react_1.useEffect)(() => {
        if (isHistory || !active || !observerWSOrders) {
            return;
        }
        const sub = observerWSOrders().subscribe((data) => {
            const { trigger_id, status, created_time, trigger_position_id } = data;
            //FIXME 过滤掉trigger_position_id不为空的订单
            if (trigger_position_id) {
                return;
            }
            const map = dataMap.current;
            const updateListData = updateRef.current;
            if (map.has(trigger_id)) {
                // 已经存在该订单
                const item = map.get(trigger_id);
                if (status !== interface_1.TriggerOrderStatus.OPEN) {
                    // 移除条件单
                    updateListData((origin) => {
                        const removeIndex = item.index;
                        // update index -1
                        for (let i = removeIndex + 1; i < origin.length; i++) {
                            const { trigger_id } = origin[i];
                            const mapData = map.get(trigger_id);
                            if (mapData) {
                                mapData.index--;
                            }
                        }
                        map.delete(trigger_id);
                        return (0, usePullRefresh_1.removeItem)(origin, removeIndex);
                    });
                    // 正常关闭
                    if (status === interface_1.TriggerOrderStatus.CANCELED) {
                        // TODO: 被撤销
                    }
                    else if (status === interface_1.TriggerOrderStatus.CLOSED) {
                        // TODO: 成功挂单
                    }
                }
                return;
            }
            if (status !== interface_1.TriggerOrderStatus.OPEN) {
                return;
            }
            // 不存在该订单，或者全新的订单
            updateListData((origin) => (0, usePullRefresh_1.insetItemIfNeed)(origin, (item) => {
                const willInsert = !item || new trade_utils_lib_1.SafeDecimal(created_time).gt(new trade_utils_lib_1.SafeDecimal(item.created_time));
                if (willInsert) {
                    // update index +1
                    for (const [, item] of map) {
                        item.index++;
                    }
                    map.set(trigger_id, { index: 0 });
                }
                return willInsert;
            }, data));
        }, (err) => {
            console.log(err);
        });
        return () => sub.unsubscribe();
    }, [active, isHistory, observerWSOrders]);
    return others;
}
exports.useTriggerOrders = useTriggerOrders;
